module.exports = __webpack_public_path__ + "img/skills-hammerdin-1.fe5d6815.png";